import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility.service';
import { PollListService } from '../../core/services/poll-list.service';
import { FeedbackService } from '../../core/services/feedback.service';

@Component({
  selector: 'app-poll-list',
  templateUrl: './poll-list.component.html',
  styleUrls: ['./poll-list.component.css'],
  providers:[PollListService,FeedbackService]
})
export class PollListComponent implements OnInit {

  eventId:string='';
  count:number=0;
  totalAnswer:number=0;
  yes:number = 0;
  no:number=0;
  dontKnow:number=0;
  eventLists:boolean = true;

  constructor(private feedbackService: FeedbackService,private pollListService:PollListService, private extraService:ExtraService,private route: ActivatedRoute,private router:Router,
    private utilityService:UtilityService) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => { 
      let id = params['eventId']; 
      this.eventId = id;
      //console.log(this.eventId)
      if(id) {
        //this.setPollData(id);
      }
    });
  }

  /*setPollData(id) {
    this.pollListService.getPollListData(id,null).subscribe(event=>{
      if(event){
        for(let key in event) {
          if(event[key].answers) {
            for(let o in event[key].answers) {
              if(event[key].answers[o] == 'Yes'){++this.yes;}
              else if(event[key].answers[o] == 'No'){++this.no;}
              else if(event[key].answers[o] == 'dontKnow'){++this.dontKnow}
            }
          } if(event[key].answersCount) {
            this.totalAnswer = this.totalAnswer+event[key].answersCount;
          }
          this.count++;
        }
        this.yes = (this.yes*100)/this.count;
        this.no = (this.no*100)/this.count;
        this.dontKnow = (this.dontKnow*100)/this.count;
        console.log(this.totalAnswer, this.yes, this.no)
      }
      
    });
  }*/
	
	
}



// WEBPACK FOOTER //
// /app/src/app/event/poll-list/poll-list.component.ts